module.exports = __webpack_public_path__ + "static/Passwordless-ec20c4945ecf346e57f363eeaee78bfc.mp4";